import { Injectable } from '@angular/core';
import { NkSidebarComponent } from './sidebar.component';

@Injectable({ providedIn: 'root' })
export class NkSidebarService {
  // Private
  private _registry: { [key: string]: NkSidebarComponent } = {};


  /**
   * Add the sidebar to the registry
   *
   * @param key
   * @param sidebar
   */
  register(key: any, sidebar: any): void {
    // Check if the key already being used
    if (this._registry[key]) {
      console.error(
        `The sidebar with the key '${key}' already exists. Either unregister it first or use a unique key.`
      );

      return;
    }

    // Add to the registry
    this._registry[key] = sidebar;
  }

  /**
   * Remove the sidebar from the registry
   */
  unregister(key: any): void {
    // Check if the sidebar exists
    if (!this._registry[key]) {
      console.warn(
        `The sidebar with the key '${key}' doesn't exist in the registry. Cant delete from registry`
      );
    }

    // Unregister the sidebar
    delete this._registry[key];
  }

  /**
   * Return the sidebar with the given key
   */
  getSidebar(key: any): NkSidebarComponent | null {
    // Check if the sidebar exists
    if (!this._registry[key]) {
      return null;
    }

    // Return the sidebar
    return this._registry[key];
  }
}
